export default __webpack_public_path__ + "static/media/lucky-spin-ico.e431c500.svg";